<template>
  <div>
    <v-layout class="px-5" style="display: flex; align-items: center">
      <v-flex xs12 sm8>
        <v-text-field
          v-model="search"
          label="Search Rider name"
          prepend-icon="search "
          class="pr-3"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm4>
        <v-select
          label="Rider Status"
          :items="['Active', 'Inactive', 'Deleted']"
          v-model="filterStatus"
        ></v-select
      ></v-flex>
    </v-layout>
    <v-data-table
      :headers="headers"
      :loading="loading_message"
      :items="searchedWallet"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">
          {{ searchedWallet.indexOf(props.item) + 1 }}
        </td>
        <td style="max-width: 200px; overflow: auto">
          {{ props.item.wallet_name }}
        </td>
        <td class="text-xs-right">
          {{
            parseFloat(props.item.wallet_cash)
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }}
        </td>
        <td class="text-xs-right">
          {{
            parseFloat(props.item.wallet_credit)
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }}
        </td>
        <td class="text-xs-center">{{ props.item.wallet_user_status }}</td>
        <td class="justify-center layout px-0">
          <v-tooltip top>
            <v-btn
              small
              slot="activator"
              :to="
                '/weserve_admin_login/control/' +
                $store.state.backOffice.province +
                '/rider/wallet/transaction/' +
                props.item.wallet_rider_id
              "
            >
              <v-icon small>remove_red_eye</v-icon>&nbsp; View transaction
            </v-btn>
            <span>View transaction</span>
          </v-tooltip>
        </td>
      </template>

      <!-- <template slot="no-data" class="text-xs-center">
            <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>-->
      <template slot="no-data">
        <div
          v-if="loading_message == false"
          style="display: flex; justify-content: center"
        >
          No data available
        </div>
        <div v-else class="text-xs-center">
          <v-progress-circular
            :size="30"
            color="primary"
            indeterminate
          ></v-progress-circular
          >Loading data ...
        </div>
      </template>
    </v-data-table>

    <!-- <div class="text-xs-center py-2">
      <v-pagination circle v-model="pagination.page" :length="pages"></v-pagination>
    </div>-->
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  // props:['rider_wallet'],
  data: () => ({
    search: "",
    loading_message: false,
    filterStatus: "Active",
    pagination: {
      rowsPerPage: 10,
    },
    headers: [
      {
        text: "No.",
        align: "center",
        value: "id",
        sortable: false,
      },
      {
        text: "Name",
        align: "center",
        value: "name",
        sortable: false,
      },
      {
        text: "Cash",
        align: "center",
        value: "cash",
        sortable: false,
      },
      {
        text: "Credit",
        align: "center",
        value: "cradit",
        sortable: false,
      },
      {
        text: "Status",
        align: "center",
        value: "status",
        sortable: false,
      },
      {
        text: "Actions",
        align: "center",
        value: "actions",
        sortable: false,
      },
    ],
  }),
  computed: {
    ...mapState({
      rider_wallet_active: (state) => state.fetchCashRider.rider_wallet,
      rider_wallet_inactive: (state) =>
        state.fetchCashRider.rider_wallet_inactive,
      rider_wallet_deleted: (state) =>
        state.fetchCashRider.rider_wallet_deleted,
    }),
    searchedWallet() {
      // search
      if (this.filterStatus == "Active") {
        return this.rider_wallet_active.filter(
          (val) => this.search == "" || val.wallet_name.includes(this.search)
        );
      } else if (this.filterStatus == "Inactive") {
        return this.rider_wallet_inactive.filter(
          (val) => this.search == "" || val.wallet_name.includes(this.search)
        );
      } else if (this.filterStatus == "Deleted") {
        return this.rider_wallet_deleted.filter(
          (val) => this.search == "" || val.wallet_name.includes(this.search)
        );
      } else {
        return [];
      }
    },
    pages() {
      this.pagination.totalItems = this.searchedWallet.length;
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
  },
  async created() {
    this.loading_message = true;
    await this.$store.dispatch("fetchCashRider/getRiderWallet");
    this.loading_message = false;
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  methods: {},
};
</script>
